export class Marca {
  ativo: boolean;
  id: number;
  marca: string;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/marcas/shared/marca.model.ts
 **/